import { useCallback, useLayoutEffect, useRef } from "react";

// Devolve uma função com identidade fixa que sempre chama a versão mais recente
// de `fn`. Serve para passar handlers a componentes com React.memo sem que eles
// re-renderizem a cada render do pai (o handler continua enxergando o estado
// atual, como antes). Só deve ser chamada a partir de eventos/efeitos, nunca
// durante o render.
const useStableCallback = (fn) => {
  const ref = useRef(fn);

  useLayoutEffect(() => {
    ref.current = fn;
  });

  return useCallback((...args) => ref.current?.(...args), []);
};

export default useStableCallback;
